function InitMatchHeight() {
	this.build();
	barbaCallbacks.push(this);
	resizeCallbacks.push(this);
}

InitMatchHeight.prototype.build = function () {
	$.fn.matchHeight._applyDataApi();
};

InitMatchHeight.prototype.resize = function () {
	this.destroy();
	$.fn.matchHeight._maintainScroll = true;
	$.fn.matchHeight._applyDataApi();
};

InitMatchHeight.prototype.destroy = function () {
	$('[data-mh]').matchHeight({ remove: true });
};